import CustomSelect from './CustomSelect';

interface CountryInputProps {
  label: string;
  placeholder: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isMandatory?: boolean;
}

// Common country list - can be extended as needed
const COUNTRIES = [
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Spain',
  'Italy',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Ireland',
  'Portugal',
  'Poland',
  'Czech Republic',
  'Greece',
  'New Zealand',
  'Singapore',
  'Hong Kong',
  'Japan',
  'South Korea',
  'India',
  'Brazil',
  'Mexico',
  'Argentina',
];

function CountryInput({
  label,
  placeholder,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
}: CountryInputProps) {
  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <CustomSelect
        value={value || ''}
        options={COUNTRIES}
        placeholder={placeholder || 'Select country...'}
        disabled={disabled}
        isInvalid={!!error}
        onChange={newValue => onChange(newValue as string)}
        multiSelect={false}
        searchable={true}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default CountryInput;
